import React from 'react';
import { NavLink } from 'react-router';
import { FaListAlt, FaTabletAlt, FaUsers, FaDoorClosed, FaCog } from 'react-icons/fa';
import { FaPeopleGroup, FaRankingStar } from 'react-icons/fa6';
import './styles.scss';

const SidebarNavigation = () => {
  return (
    <nav className='sidebar-navigation-wrapper'>
      <ul className="nav">
        <NavLink to="/users" className={'nav-item'}>
          <FaUsers/>
          <span>
            Users
          </span>
        </NavLink>

        <NavLink to="/devices" className={'nav-item'}>
          <FaTabletAlt/>
          <span>
            Devices
          </span>
        </NavLink>

        <NavLink to="/protocols" className={'nav-item'}>
          <FaCog/>
          <span>
            Protocols
          </span>
        </NavLink>

        <NavLink to="/sessions" className={'nav-item'}>
          <FaListAlt/>
          <span>
            Sessions
          </span>
        </NavLink>

        <NavLink to="/leaderboards" className={'nav-item'}>
          <FaRankingStar/>
          <span>
            Leaderboards
          </span>
        </NavLink>

        <NavLink to="/leagues" className={'nav-item'}>
          <FaPeopleGroup/>
          <span>
            Leagues
          </span>
        </NavLink>

        <NavLink to="/logout" className={'nav-item'}>
          <FaDoorClosed/>
          <span>
            Logout
          </span>
        </NavLink>
      </ul>
    </nav>
  )
};

export default SidebarNavigation;
